import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import * as React from 'react';
import { NavLink, useParams } from 'react-router-dom';

type Params = {
  productId: string;
};

type BreadcrumbProps = {
  title: string;
};

function Breadcrumb({ title }: BreadcrumbProps) {
  const params = useParams<Params>();
  const productId = Number(params.productId);

  return (
    <Breadcrumbs>
      <NavLink to='/producer/dashboard'>Home</NavLink>
      <NavLink to='/producer/product/myproducts'>Meus produtos</NavLink>
      <NavLink to={`/producer/product/editproduct/${productId}/subscriptionplan`}>Edição do produto</NavLink>
      <p>{title}</p>
    </Breadcrumbs>
  );
}

export { Breadcrumb };
